function renderBundleDisplay() {
  const maxSlots = 3;

  // Create main container
  const bundleItemsList = document.createElement('div');
  bundleItemsList.className = 'bundle-items-list';

  // Create cushion stack section
  const cushionStack = document.createElement('div');
  cushionStack.className = 'cushion-bundle--stack';

  // Add transparent images to stack
  bundleCart.getItems().forEach((item) => {
    const img = document.createElement('img');
    img.src = item.transparentImage.startsWith('//') ? `https:${item.transparentImage}` : item.transparentImage;
    img.alt = item.title;
    img.width = 100;
    img.height = 100;
    cushionStack.appendChild(img);
  });

  // Add cushion stack to main container
  bundleItemsList.appendChild(cushionStack);

  // Add bundle items
  bundleCart.getItems().forEach((item, index) => {
    const bundleItem = document.createElement('div');
    bundleItem.className = 'bundle-item';

    // Remove button
    const removeButton = document.createElement('button');
    removeButton.className = 'bundle-remove';
    removeButton.setAttribute('data-index', index);
    removeButton.setAttribute('data-id', item.id);
    removeButton.type = 'button';
    removeButton.innerHTML = `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        width="12"
        height="12"
      >
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
      </svg>
    `;

    // Image container
    const imageContainer = document.createElement('div');
    imageContainer.className = 'bundle-item--image';

    const imageLink = document.createElement('a');
    imageLink.href = `/products/${item.handle}`;

    const productImage = document.createElement('img');
    productImage.src = item.image.startsWith('//') ? `https:${item.image}` : item.image;
    productImage.alt = item.title;
    productImage.width = 100;
    productImage.height = 100;

    imageLink.appendChild(productImage);
    imageContainer.appendChild(imageLink);

    // Content container
    const contentContainer = document.createElement('div');
    contentContainer.className = 'bundle-item--content';

    const title = document.createElement('h3');
    title.className = 'bundle-item--title';

    const titleLink = document.createElement('a');
    titleLink.href = `/products/${item.handle}`;

    const titleSpan = document.createElement('span');
    titleSpan.textContent = `${item.title}`;

    titleLink.appendChild(titleSpan);
    title.appendChild(titleLink);
    contentContainer.appendChild(title);

    // Append all elements to bundle item
    bundleItem.appendChild(removeButton);
    bundleItem.appendChild(imageContainer);
    bundleItem.appendChild(contentContainer);

    // Add bundle item to main container
    bundleItemsList.appendChild(bundleItem);
  });

  // Add empty slots
  const remainingSlots = maxSlots - bundleCart.getItems().length;
  for (let i = 0; i < remainingSlots; i++) {
    const emptySlot = document.createElement('div');
    emptySlot.className = 'bundle-item bundle-item--empty';

    const addButton = document.createElement('button');
    addButton.type = 'button';
    addButton.onclick = () => {
      window.location.href = window.location.href.includes('/ar/')
        ? '/ar/collections/make-your-own-cushion-bundle'
        : '/collections/make-your-own-cushion-bundle';
    };

    const strongPlus = document.createElement('strong');
    strongPlus.textContent = '+';

    addButton.appendChild(strongPlus);
    addButton.appendChild(document.createElement('br'));
    addButton.appendChild(
      document.createTextNode(getTranslation('cushion_bundle.add_more_label', { qty: remainingSlots }))
    );

    const bundleCount = document.createElement('div');
    bundleCount.className = 'bundle-count';

    emptySlot.appendChild(addButton);
    emptySlot.appendChild(bundleCount);

    bundleItemsList.appendChild(emptySlot);
  }

  return bundleItemsList;
}

// Helper function for translations
function getTranslation(key, variables) {
  const translations = {
    'cushion_bundle.add_more_label': {
      en: 'Add {qty} more',
      ar: 'أضف {qty} أخرى',
    },
  };

  const locale = getCurrentLocale();
  let translation = translations[key][locale];

  if (variables) {
    Object.keys(variables).forEach((varKey) => {
      translation = translation.replace(`{${varKey}}`, variables[varKey]);
    });
  }

  return translation;
}

function renderBundleDisplay2() {
  const container = document.querySelector('#bundle-container');

  if (container) {
    container.innerHTML = '';
    container.appendChild(renderBundleDisplay());
    // Handle remove buttons
    document.querySelectorAll('.bundle-remove').forEach((button) => {
      button.addEventListener('click', handleRemoveItem);
    });
  }

  // Hide empty bundle list
  const emptyItems = document.querySelectorAll('.bundle-items-list .bundle-item.bundle-item--empty');
  const bundleList = document.querySelector('.bundle-items-list');
  if (bundleList && emptyItems.length === 3) {
    bundleList.style.display = 'none';
  }
}

// Initialize the bundle display
function initBundleDisplay() {
  bundleCart.load();
  renderBundleDisplay2();

  handleAddBundleItem();
}

function handleAddBundleItem() {
  const makeCushionButton = document.querySelector('.btn--bundle');

  if (makeCushionButton) {
    makeCushionButton.addEventListener('click', function () {
      const button = event.currentTarget;

      const newItem = {
        id: button.getAttribute('data-variant-id'),
        handle: button.getAttribute('data-product-handle'),
        title: button.getAttribute('data-product-title'),
        image: button.getAttribute('data-product-image'),
        transparentImage: button.getAttribute('data-transparent-image'),
        variantTitle: button.getAttribute('data-variant-title'),
        price: button.getAttribute('data-price'),
      };

      bundleCart.add(newItem);

      renderBundleDisplay2();
      modifyFHTCartWithBundle();
      if (bundleCart.getCount() > 0) {
        button.innerHTML = getCurrentLocale() == 'ar' ? 'أضف إلى مجموعتك' : 'Add to your bundle';
      }
    });
  }

  if (bundleCart.getCount() > 0) {
    makeCushionButton.innerHTML = getCurrentLocale() == 'ar' ? 'أضف إلى مجموعتك' : 'Add to your bundle';
  }
  modifyFHTCartWithBundle();
}

function handleRemoveItem(event) {
  const index = parseInt(event.currentTarget.getAttribute('data-index'));
  const id = event.currentTarget.getAttribute('data-id');
  bundleCart.remove({ id: id });
  modifyFHTCartWithBundle();
  const makeCushionButton = document.querySelector('.btn--bundle');
  renderBundleDisplay2();
  if (bundleCart.getCount() > 0) {
    makeCushionButton.innerHTML = getCurrentLocale() == 'ar' ? 'أضف إلى مجموعتك' : 'Add to your bundle';
    document.querySelector('#bundle-icon-bubble').classList.add('show');
  } else {
    makeCushionButton.innerHTML =
      getCurrentLocale() == 'ar' ? 'تسوق المجموعة واحصل على خصم 5٪' : 'Make your bundle and save 5%';
    document.querySelector('#bundle-icon-bubble').classList.remove('show');
  }
}

// Call this when your page loads
document.addEventListener('DOMContentLoaded', initBundleDisplay);
